import React from 'react';
import I18n from '../../components/i18n';

export default function() {
  return (
    <div className="default-view">
      <div className="text-center">
        <h2>
          <I18n t="default-view.title" />
        </h2>
      </div>
    </div>
  );
}
